import { z } from 'zod'

import type { WarmupDTO } from '../api/models'
import { WarmupApi } from '../api'
import { getApiConfig } from './api-config'
import { yearWeekSchema } from './dal-utils'
import { normalizeDateForApiQuery } from './exercise-date-utils'

const weekdayCompletionFlagSchema = z.boolean()

export const warmupWeekdayCompletionSchema = z.object({
  monday: weekdayCompletionFlagSchema,
  tuesday: weekdayCompletionFlagSchema,
  wednesday: weekdayCompletionFlagSchema,
  thursday: weekdayCompletionFlagSchema,
  friday: weekdayCompletionFlagSchema,
  saturday: weekdayCompletionFlagSchema,
  sunday: weekdayCompletionFlagSchema,
})

export type WarmupWeekdayCompletion = z.infer<
  typeof warmupWeekdayCompletionSchema
>

export async function fetchWarmupWeekdayCompletion(yearWeek: string) {
  const parsedYearWeek = yearWeekSchema.parse(yearWeek)
  try {
    const warmupApi = new WarmupApi(getApiConfig())
    const summary = await warmupApi.apiWarmupSummaryGet({
      yearWeek: parsedYearWeek,
    })

    return warmupWeekdayCompletionSchema.parse({
      monday: summary.monday,
      tuesday: summary.tuesday,
      wednesday: summary.wednesday,
      thursday: summary.thursday,
      friday: summary.friday,
      saturday: summary.saturday,
      sunday: summary.sunday,
    })
  } catch (error) {
    console.warn('Failed to fetch warmup summary', error)
    return null
  }
}

export async function saveWarmupCompletion({
  timeSpent = 1,
  date = new Date(),
}: {
  timeSpent?: number
  date?: Date
}) {
  const warmupApi = new WarmupApi(getApiConfig())
  const warmupDTO: WarmupDTO = {
    date: normalizeDateForApiQuery(date),
    timeSpent,
  }

  await warmupApi.apiWarmupPost({
    warmupDTO,
  })
}
